import React from 'react';
import LineChart from './LineChart';
import BarChart from './BarChart';
import PieChart from './PieChart';
import './Charts.css';

const ResourceAnalytics = ({ data = {} }) => {
  const {
    downloadsByResource = [{ timestamp: new Date(), value: 0 }],
    downloadsByCategory = [{ category: 'No Data', downloads: 0, percentage: 0 }],
    viewTimeByResource = [{ resourceId: 'none', viewTime: 0 }],
    searchTerms = [],
    resourceEngagement = [{ title: 'No Downloads Yet', downloads: 0 }],
    categoryViews = [{ category: 'No Views', views: 0 }]
  } = data || {};

  // Calculate metrics with zero-state handling
  const totalDownloads = resourceEngagement.reduce((acc, curr) => acc + (curr.downloads || 0), 0);
  const mostDownloaded = resourceEngagement[0]?.downloads > 0 
    ? resourceEngagement[0].title 
    : 'No downloads yet';
  const averageViewTime = viewTimeByResource.some(item => item.viewTime > 0)
    ? Math.round(viewTimeByResource.reduce((acc, curr) => acc + (curr.viewTime || 0), 0) / viewTimeByResource.length)
    : 0;

  return (
    <div className="resource-analytics">
      <div className="charts-grid">
        <div className="chart-container">
          <h3>Resource Downloads Over Time</h3>
          <LineChart 
            data={downloadsByResource}
            xAxis="Date"
            yAxis="Downloads"
          />
        </div>

        <div className="chart-container">
          <h3>Most Popular Resources</h3>
          <BarChart 
            data={resourceEngagement.map(item => ({
              x: item.title,
              y: item.downloads || 0
            }))}
            xAxis="Resource"
            yAxis="Total Downloads"
          />
        </div>

        <div className="chart-container">
          <h3>Downloads by Category</h3>
          <PieChart 
            data={downloadsByCategory.map(item => ({
              label: item.category,
              value: item.downloads || 0,
              percentage: item.percentage || 0
            }))}
          />
        </div>

        <div className="metrics-overview">
          <div className="metric-card">
            <h4>Total Downloads</h4>
            <p>{totalDownloads || 0}</p>
          </div>
          <div className="metric-card">
            <h4>Most Downloaded</h4>
            <p>{mostDownloaded}</p>
          </div>
          <div className="metric-card">
            <h4>Avg. View Time</h4>
            <p>{averageViewTime || 0}s</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceAnalytics; 